// eslint-disable-next-line
export const appOrStage = [
	'Application Instance',
	'Submission Stage',
	'Evaluation Stage',
	'Review Stage'
];

export const disabledStatuses = [
	'Pending Decision',
	'On Hold',
	'Rec for Award',
	'Rejected',
	'Full Review',
	'Closed'
];

export const applicationStageStatuses = {
	NOT_STARTED: 'Not Started',
	IN_PROGRESS: 'In Progress'
};

export const applicationStatuses = {
	AWARDED: 'Rec for Award',
	REJECTED: 'Rejected'
};
